import { Card, CardContent, Typography } from "@mui/material";

export default function Widget({ title, children }) {
  return (
    <Card sx={{ height: "100%" }}>
      <CardContent>
        <Typography variant="subtitle1" fontWeight={600} mb={1}>
          {title}
        </Typography>
        {children}
      </CardContent>
    </Card>
  );
}
